import styled from "styled-components";

import Tile from "shared/components/Tile";
import { COLORS, MEDIA_QUERIES } from "shared/config/constants";

const TABLE_BORDER = `1px solid ${COLORS.borders}`;

const CosignTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const CosignSummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 8px;
  margin-bottom: 24px;
`;

const CosignSummaryItem = styled.div`
  min-width: 160px;
`;

const CosignPmUuidSummaryItem = styled(CosignSummaryItem)`
  flex: 1 1 360px;
  min-width: 360px;
  max-width: 100%;
`;

const CosignPmUuidEditContainer = styled.div`
  width: 100%;
  max-width: 420px;

  input,
  .ant-input {
    width: 100%;
    font-family: monospace;
    font-size: 14px;
  }
`;

const CosignSummaryLabel = styled.div`
  font-size: 12px;
  color: ${COLORS.textColorSecondary};
  margin-bottom: 4px;
`;

const CosignSummaryValue = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

const CosignMonospaceValue = styled.div`
  font-family: monospace;
  font-size: 14px;
  font-weight: 600;
`;

const TableSection = styled(Tile)`
  margin-bottom: 24px;
`;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: ${TABLE_BORDER};
  background-color: ${COLORS.white};

  h2 {
    margin: 0;
    font-size: 18px;
  }

  ${MEDIA_QUERIES.w.ltMd} {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const TableWrapper = styled.div`
  border-top: ${TABLE_BORDER};
`;

const StatusBadge = styled.span<{ $variant: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  background-color: ${({ $variant }) => {
    if ($variant === "active") return "#e6f7ed";
    if ($variant === "onboarding") return "#fff6e6";
    if ($variant === "disabled") return "#f5f5f5";
    return "#f0f0f0";
  }};
  color: ${({ $variant }) => {
    if ($variant === "active") return COLORS.green;
    if ($variant === "onboarding") return COLORS.warning;
    if ($variant === "disabled") return COLORS.textColorSecondary;
    return COLORS.textColorSecondary;
  }};
`;

const StatusBadgeWrapper = styled.span`
  display: inline-flex;
  cursor: help;
`;

const CopyUuidButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin-left: 8px;
  cursor: pointer;
  font-size: 12px;
  color: ${COLORS.button.transparent.green.default.text};
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
`;

const UuidCell = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-family: monospace;
  font-size: 13px;
`;

const DashboardError = styled.p`
  color: ${COLORS.red};
  margin: 16px 0;
`;

const DashboardWarningBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 12px 16px;
  border: 1px solid ${COLORS.warning};
  border-radius: 8px;
  background-color: #fdeee9;
  color: ${COLORS.warning};
  font-size: 14px;
  line-height: 1.5;

  strong {
    display: block;
    margin-bottom: 2px;
  }
`;

const CosignPmUuidViewRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const CosignPmUuidEditActions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

const CosignPmUuidEditError = styled.div`
  color: ${COLORS.red};
  font-size: 13px;
  margin-top: 8px;
`;

const InactiveMappedRowCell = styled.div<{ $inactive?: boolean }>`
  ${({ $inactive }) =>
    $inactive &&
    `
      opacity: 0.65;
      color: ${COLORS.textColorSecondary};
    `}
`;

const CosignDisabledLabel = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${COLORS.textColorSecondary};
  background-color: ${COLORS.borders};
`;

export {
  CosignTitleContainer,
  CosignSummaryRow,
  CosignSummaryItem,
  CosignPmUuidSummaryItem,
  CosignPmUuidEditContainer,
  CosignSummaryLabel,
  CosignSummaryValue,
  CosignMonospaceValue,
  TableSection,
  TableHeader,
  TableWrapper,
  StatusBadge,
  StatusBadgeWrapper,
  CopyUuidButton,
  UuidCell,
  DashboardError,
  DashboardWarningBanner,
  CosignPmUuidViewRow,
  CosignPmUuidEditActions,
  CosignPmUuidEditError,
  InactiveMappedRowCell,
  CosignDisabledLabel,
};
